import React, { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import { addWorkLinePlaceGroupAPI } from '../../../../api/workLinePlaceGroup/workLinePlaceGroupAPI'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../UI/messages/ErrorMessage'

const WorkLinePlaceGroupAdd = ({ usersWork, workLinePlaceId }) => {

    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const addGroup = () => {
        setLoading(true)
        addWorkLinePlaceGroupAPI({
            usersWork, workLinePlaceId
        }).then(data => {
            setLoading(false)

            // оновлюємо сторінку після успішного додавання групи
            window.location.reload()
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage error={error} />

        <MyButton
            size='md'
            onClick={addGroup}
            disabled={loading ? true : false}
        >
            Зберегти групу людей
        </MyButton>
    </div>
  )
}

export default WorkLinePlaceGroupAdd